import React, { Component, useEffect, useRef, useState } from 'react';
import { Box, Typography, Button, LinearProgress, Modal, Dialog } from '@mui/material';
// import { withStyles } from '@material-ui/core/styles'
import './style.css';
import UploadService from './upload-files.service';
import Api from 'app/services/api';
import { translate } from 'translate';
import ConfirmationDialog from 'app/views/material-kit/dialog/ConfirmationDialog';

const UUIDRegex =
  /[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}/i;

// const BorderLinearProgress = withStyles((theme) => ({
//   root: {
//     height: 15,
//     borderRadius: 5,
//   },
//   colorPrimary: {
//     backgroundColor: "#EEEEEE",
//   },
//   bar: {
//     borderRadius: 5,
//     backgroundColor: '#1a90ff',
//   },
// }))(LinearProgress);

const ImageUpload = (props) => {
  const { id, fileInfo, onChange, name, value } = props;
  // console.log(props)

  const [previewImage, setPreviewImage] = useState(value ? Api.getPhotoUrl(value) : undefined);
  const [progress, setProgress] = useState(0);
  const [message, setMessage] = useState('');
  const [isError, setIsError] = useState(false);
  const [uuid, setUuid] = useState();
  const [isUploading, setIsUploading] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);

  // const [imageValue, setImageValue] = useState('')

  const selectFile = (event) => {
    setProgress(0);
    setMessage('');
    if (event.target.files[0]) {
      upload(event.target.files[0]);
    }
    // console.log((event))
  };

  const handleDeleteImage = async () => {
    setProgress(0);
    await UploadService.delete(uuid);
    setPreviewImage(undefined);
    onChange(null);
    // @ts-expect-error
    inputFile.current.value = '';
  };

  useEffect(() => {
    if (value) {
      // console.log('value', value.match(UUIDRegex)[0])
      setUuid(value.match(UUIDRegex)[0]);
    }
    setPreviewImage(value ? Api.getPhotoUrl(value) : undefined);
  }, [value]);

  const upload = async (file) => {
    setProgress(0);
    setIsUploading(true);
    try {
      const response = await UploadService.upload(file, fileInfo, (event) => {
        setProgress(Math.round((100 * event.loaded) / event.total));
      });
      setMessage('');
      setIsError(false);
      setUuid(response.file_uuid);
      // setImageValue(response.file_uuid)

      var event = new Event('change');
      // await UploadService.getFiles();
      setPreviewImage(Api.getPhotoUrl(response.url));
      console.log('hello');
      setShowConfirmationModal(true);
      onChange(response.url);
    } catch (e) {
      console.log(e);
      setProgress(0);
      setMessage('Could not upload the image!');
      setIsError(true);
    } finally {
      setIsUploading(false);
    }
  };
  if (fileInfo.purpose === 'profile_pic') {
    // console.log(value, previewImage)
  }
  const inputFile = useRef(null);

  return (
    <div>
      <label htmlFor={id}>
        <input
          id={id}
          style={{ display: 'none' }}
          type="file"
          ref={inputFile}
          accept="application/octet-stream image/*"
          onChange={selectFile}
        />
        {!previewImage && (
          <Button className="btn-choose" variant="outlined" component="span">
            {translate('Choose Image')}
          </Button>
        )}
      </label>

      <Dialog open={showConfirmationModal} onClose={() => setShowConfirmationModal(false)}>
        <div className="flex flex-col items-center p-10">
          <div className="text-lg font-bold mb-4">از آپلود این عکس مطمئنید؟</div>
          <img className="preview" src={previewImage} alt="" />
          <div className="flex justify-between mt-2 gap-4">
            <button
              onClick={() => {
                setShowConfirmationModal(false);
                // onChange(uuid)
              }}
              className="bg-primary text-white p-2  px-4 rounded-3xl cursor-pointer"
            >
              تایید
            </button>
            <button
              onClick={() => {
                setShowConfirmationModal(false);
                handleDeleteImage();
                inputFile.current?.click();
              }}
              className="bg-red-500 text-white p-2 px-4 rounded-3xl cursor-pointer mr-2"
            >
              اصلاح
            </button>
          </div>
        </div>
      </Dialog>

      {previewImage && (
        <div className="flex items-center w-24">
          <img className="preview" src={previewImage} alt="" />
          <Button
            onClick={handleDeleteImage}
            className="ml-10"
            color="secondary"
            variant="outlined"
          >
            Delete
          </Button>
        </div>
      )}

      {isUploading && <LinearProgress variant="determinate" value={progress} />}
      {message && (
        <Typography variant="subtitle2" className={`upload-message ${isError ? 'error' : ''}`}>
          {message}
        </Typography>
      )}
    </div>
  );
};

export default ImageUpload;
